export default [
  {
    title: 'breadcrumb.matchVideo',
    route: 'list-match-video',
    icon: '',
    resource: 'video-live-upload',
    action: 'read',
  },
]
